export default __webpack_public_path__ + "static/media/peterpan-logo.e91352f1.svg";